import React, { useContext, useEffect } from "react";
import PagePreview from "./Preview";
import { useSelector } from "react-redux";
import { FullGridContext } from "../..";
import { getData } from "~/functions/gridFunctions";
import PageContainer from "~/components/PageContainer";
import { format, parseISO } from "date-fns";
import { formatter } from "~/functions";

function safeDate(value) {
  if (!value) return "-";
  try {
    return format(parseISO(value), "MM/dd/yyyy");
  } catch (err) {
    return "-";
  }
}

export default function OtherConciliation() {
  const filial = useSelector((state) => state.auth.filial);
  const defaultOrderBy = { column: "conciliation_date", asc: false };
  const defaultGridHeader = [
    {
      title: "Type",
      name: "type",
      type: "text",
      filter: true,
    },
    {
      title: "Period",
      name: "period",
      type: "text",
      filter: false,
    },
    {
      title: "Conciliation Date",
      name: "conciliation_date",
      type: "text",
      filter: false,
    },
    {
      title: "Amount",
      name: "total_amount",
      type: "text",
      filter: false,
    },
    {
      title: "Items",
      name: "items",
      type: "text",
      filter: false,
    },
    {
      title: "Status",
      name: "status",
      type: "text",
      filter: true,
    },
  ];

  const {
    accessModule,
    limit,
    opened,
    orderBy,
    page,
    search,
    setGridData,
    setGridDetails,
    setLoadingData,
    setPage,
    setPages,
    setSearch,
  } = useContext(FullGridContext);

  const pageAccess = accessModule.children.find(
    (el) => el.alias === "other_conciliations"
  );

  useEffect(() => {
    setSearch("");
    setPage(1);
  }, []);

  async function loader() {
    setLoadingData(true);
    const data = await getData("otherconciliations", {
      limit,
      page,
      orderBy,
      setPages,
      setGridData,
      search,
      defaultGridHeader,
      defaultOrderBy,
      setGridDetails,
    });
    if (!data) {
      setGridData([]);
      setLoadingData(false);
      return;
    }
    const gridDataValues = data.map((row, index) => {
      const {
        id,
        type,
        date_from,
        date_to,
        conciliation_date,
        total_amount,
        total_items,
        items,
        status,
        canceled_at,
      } = row;

      const count = total_items ?? items?.length;

      return {
        show: true,
        id,
        fields: [
          type,
          `${safeDate(date_from)} - ${safeDate(date_to)}`,
          safeDate(conciliation_date),
          formatter.format(Number(total_amount || 0)),
          count === undefined ? "-" : String(count),
          status,
        ],
        canceled: canceled_at,
        page: Math.ceil((index + 1) / limit),
      };
    });
    setGridData(gridDataValues);
    setLoadingData(false);
  }

  useEffect(() => {
    if (!opened) {
      loader();
    }
  }, [opened, filial, orderBy, search, limit, page]);

  return (
    <PageContainer
      FullGridContext={FullGridContext}
      PagePreview={PagePreview}
      pageAccess={pageAccess}
      defaultGridHeader={defaultGridHeader}
    />
  );
}
